export type DevicesView = "table" | "layout";

export const DEVICES_VIEWS: Record<Uppercase<DevicesView>, DevicesView> = {
  TABLE: "table",
  LAYOUT: "layout",
} as const;

export const isDevicesView = (value: unknown): value is DevicesView =>
  value === DEVICES_VIEWS.TABLE || value === DEVICES_VIEWS.LAYOUT;
